import __request__ from 'routing/request';
interface MediaType {
    readonly wildcard_subtype: boolean;
    readonly subtype: string;
    readonly wildcard_type: boolean;
    readonly type: string;
    readonly parameters: {
        readonly [_key: string]: string;
    };
}
interface MimecastV2RequestImpl {
    readonly client_secret: unknown;
    readonly client_id: string;
}
interface MimecastV2CreateInputRequest {
    readonly polling_time_unit: 'NANOSECONDS' | 'MICROSECONDS' | 'MILLISECONDS' | 'SECONDS' | 'MINUTES' | 'HOURS' | 'DAYS';
    readonly content_type: string[];
    readonly name: string;
    readonly client_secret: unknown;
    readonly enable_throttling: boolean;
    readonly polling_interval: number;
    readonly client_id: string;
}
/**
 * Validate API Credentials
 */
export function checkCredentials(JSONbody: MimecastV2RequestImpl): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.mimecastv2.api.MimecastV2Resource/mimecast_v2/check_credentials', JSONbody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Create a new Mimecast v2 input
 */
export function create(JSONbody: MimecastV2CreateInputRequest, setup_wizard: boolean = false): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.mimecastv2.api.MimecastV2Resource/mimecast_v2/inputs', JSONbody, { 'setup_wizard': setup_wizard }, {
        'Accept': ['application/json']
    });
}
